module.exports = __webpack_public_path__ + "static/media/whalePod.a541cd51.svg";